<template>
  <div class="box9">
    <div class="box9block" ref="block"></div>
    <div class="item-box">
      <div
        class="item"
        v-for="(item, index) in rightlist"
        :key="index"
        ref="item"
      >
        <div class="item-top" @click="changeCur(index)">
          <div class="tag">
            {{ leftList[index].num }}
          </div>
          <div class="title">{{ leftList[index].txt }}</div>
          <div
            class="icon"
            :class="{ 'img-rotate': cur == index && showAnswer }"
          >
            <img src="../../../assets/coursePage/ai/box6/icon-down.png" alt />
          </div>
        </div>

        <div
          class="answer"
          :class="{ 'show-answer': cur == index && showAnswer }"
        >
          <div class="line"></div>
          <div class="content">
            <div
              class="secondItem"
              v-for="(item2, index2) in item.title"
              :key="index2"
            >
              <div class="infotitle">{{ item2 }}</div>
              <div class="info">{{ item.txt1[index2] }}</div>
              <div class="superiority">
                <div class="text">
                  <p v-for="(i, j) in item.txt2[index2]" :key="j">{{ i }}</p>
                </div>
                <div class="img-box" @click="prveImg(index, index2)">
                  <img
                    :src="
                      require(`../../../assets/coursePage/dataAnalysis/box9/${
                        index + 1
                      }${index2 + 1}.png`)
                    "
                    alt
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <previewImage
      :list="list"
      @close="close"
      :clickedIndex="clickedIndex"
      :isPreview="isPreview"
      :style="{ left: 0 }"
    />
  </div>
</template>

<script>
import previewImage from "../common/previewImage.vue";
export default {
  components: {
    previewImage,
  },
  mounted() {},

  data() {
    return {
      show: false,
      cur: -1,
      leftList: [
        { txt: "产品线分析案例集", num: "案例一" },
        { txt: "客户分析案例集", num: "案例二" },
        { txt: "营销分析案例集", num: "案例三" },
        { txt: "抓取豆瓣电影TOP250案例", num: "案例四" },
        { txt: "Pandas 就业数据分析", num: "案例五" },
        { txt: "Google Play数据探索性数据分析案例", num: "案例六" },
        { txt: "Python实现RFM用户分群案例", num: "案例七" },
        { txt: "用户流失预警案例", num: "案例八" },
        { txt: "Tableau-covid19案例", num: "案例九" },
        { txt: "数据分析报告案例", num: "案例十" },
      ],
      rightlist: [
        {
          title: ["产品线探索分析", "产品线评估", "产品线价值分析"],
          txt1: [
            "为了解公司产品线的实际情况，该分析需基于实际产品线数据进行如下分析，用以了解产品线概况--品类分析、利润分析、价格带分析。",
            "为了客观的衡量产品线的健康程度，基于真实数据对多产品线进行对比分析。",
            "对某公司投放母婴市场的产品线进行分析，满足公司对客户群中客户群质量衡量以及自身平台与市场契合程度的评估。",
          ],
          txt2: [
            ["Tableau 条形图", "箱型图分析技巧", "Tableau 数据库数据源处理"],
            ["Tableau 条形图", "箱型图分析技巧", "Tableau 数据库数据源处理"],
            ["Tableau 条形图", "箱型图分析技巧", "Tableau 数据库数据源处理"],
          ],
        },
        {
          title: ["客户分类分析", "客户漏斗分析", "客户RFM分析"],
          txt1: [
            "依靠传统的数据图表，我们仅仅知道所有消费者行为的共同结果，但没有获得任何附加的个体消费信息。基于这种背景特提出消费者行为分析，对客户进行分类分析。",
            "通过漏斗分析，来分析某母婴产品的用户留存情况，用以降低老用户流失。",
            "使用RFM模型对用户进行价值划分。",
          ],
          txt2: [
            ["Tableau数据分布分析", "Tableau中实现聚类"],
            ["Tableau漏斗分析", "按地域进行横向的对比分析"],
            ["Tableau中复杂计算的实施", "RFM模型的理解"],
          ],
        },
        {
          title: ["客户营销分析", "营销渠道分析", "营销A/B测试"],
          txt1: [
            "关于营销活动的效果和客户关系的维护，通过数据分析评估不同方法达成效果。",
            "营销部门免不了要和媒体打交道，但是合作媒体的价值到底怎么评估呢？基于这样一个思路，特以电视媒体的收视情况来评估下电视媒体的渠道价值。",
            "需观察同一产品的不同内容版本广告对销售的影响。理想情况下，可以选择两组实验人群，保证两个群体的人口特征基本相同，对两个群体投放不同的广告，观察一段时间后产品购买量是否有显著的差异，以判断广告效果是否有差异。",
          ],
          txt2: [
            ["数据可视化的互动技巧", "数据处理"],
            ["关键指数的相关知识", "复杂可视化图形的创建"],
            ["AB测试相关理论知识", "复杂运算在可视化软件中的实施"],
          ],
        },
        {
          title: ["前端可视化"],
          txt1: [
            "用Python爬取豆瓣TOP250电影信息，带领学员从基础的分析到具体实战，层层深入，获取电影相关信息并且保存数据库。",
            "用Python爬取豆瓣TOP250电影信息，带领学员从基础的分析到具体实战，层层深入，获取电影相关信息并且保存数据库。",
            "用Python爬取豆瓣TOP250电影信息，带领学员从基础的分析到具体实战，层层深入，获取电影相关信息并且保存数据库。",
          ],
          txt2: [
            ["requests", "xpath", "lxml", "Python文件读写"],
            ["requests", "xpath", "lxml", "Python文件读写"],
            ["requests", "xpath", "lxml", "Python文件读写"],
          ],
        },
        {
          title: ["Pandas 就业数据分析"],
          txt1: [
            "从就业城市、就业薪资、招聘公司、经验要求、学历要求等多个方面，分析市场对数据分析人才的需求情况。",
            "从就业城市、就业薪资、招聘公司、经验要求、学历要求等多个方面，分析市场对数据分析人才的需求情况。",
            "从就业城市、就业薪资、招聘公司、经验要求、学历要求等多个方面，分析市场对数据分析人才的需求情况。",
          ],
          txt2: [
            ["Pandas处理数据", "pyecharts绘图"],
            ["Pandas处理数据", "pyecharts绘图"],
            ["Pandas处理数据", "pyecharts绘图"],
          ],
        },
        {
          title: ["Google Play数据探索性数据分析"],
          txt1: [
            "按照手机应用商店中下载、评分、价格、类别等数据进行探索性分析，找到应用市场中最受欢迎的应用类别，并分析价格最高的应用。分析评分最高的应用具有哪些特点。",
            "按照手机应用商店中下载、评分、价格、类别等数据进行探索性分析，找到应用市场中最受欢迎的应用类别，并分析价格最高的应用。分析评分最高的应用具有哪些特点。",
            "按照手机应用商店中下载、评分、价格、类别等数据进行探索性分析，找到应用市场中最受欢迎的应用类别，并分析价格最高的应用。分析评分最高的应用具有哪些特点。",
          ],
          txt2: [
            ["Pandas数据处理", "Matplotlib和Seaborn绘图"],
            ["Pandas数据处理", "Matplotlib和Seaborn绘图"],
            ["Pandas数据处理", "Matplotlib和Seaborn绘图"],
          ],
        },
        {
          title: ["Python实现RFM用户分群"],
          txt1: [
            "RFM是判断用户价值的重要指标，通过对某电商企业的销售数据进行分析，计算出用户的最近一次消费时间（R），消费频率（F），消费总金额（M）对用户进行价值度划分，从而对不同价值度的用户采取差异化的运营策略，实现精细化运营。",
            "RFM是判断用户价值的重要指标，通过对某电商企业的销售数据进行分析，计算出用户的最近一次消费时间（R），消费频率（F），消费总金额（M）对用户进行价值度划分，从而对不同价值度的用户采取差异化的运营策略，实现精细化运营。",
            "RFM是判断用户价值的重要指标，通过对某电商企业的销售数据进行分析，计算出用户的最近一次消费时间（R），消费频率（F），消费总金额（M）对用户进行价值度划分，从而对不同价值度的用户采取差异化的运营策略，实现精细化运营。",
          ],
          txt2: [
            [
              "Pandas Numpy进行数据处理",
              "pymysql读写MySQL数据库",
              "pyecharts绘制可交互式的3D图",
            ],
            [
              "Pandas Numpy进行数据处理",
              "pymysql读写MySQL数据库",
              "pyecharts绘制可交互式的3D图",
            ],
            [
              "Pandas Numpy进行数据处理",
              "pymysql读写MySQL数据库",
              "pyecharts绘制可交互式的3D图",
            ],
          ],
        },
        {
          title: ["用户流失预警"],
          txt1: [
            "通过对流失用户的特征进行分析，找到流失用户的特点，从而降低用户流失率。",
            "通过对流失用户的特征进行分析，找到流失用户的特点，从而降低用户流失率。",
            "通过对流失用户的特征进行分析，找到流失用户的特点，从而降低用户流失率。",
          ],
          txt2: [
            [
              "Pandas数据处理",
              "Matplotlib数据可视化",
              "SMOTE实现样本不均衡问题处理",
              "XGBoost分类算法来实现规则提取",
              "Sklearn进行模型评估",
            ],
            [
              "Pandas数据处理",
              "Matplotlib数据可视化",
              "SMOTE实现样本不均衡问题处理",
              "XGBoost分类算法来实现规则提取",
              "Sklearn进行模型评估",
            ],
            [
              "Pandas数据处理",
              "Matplotlib数据可视化",
              "SMOTE实现样本不均衡问题处理",
              "XGBoost分类算法来实现规则提取",
              "Sklearn进行模型评估",
            ],
          ],
        },
        {
          title: ["Tableau-covid19"],
          txt1: [
            "通过制作仪表板对重要业务指标进行可视化展示是数据分析工作中的一项重要技能。案例通过Tableau制作仪表板分析新冠疫情的传播和疫情现状，进一步练习仪表板的使用。",
            "通过制作仪表板对重要业务指标进行可视化展示是数据分析工作中的一项重要技能。案例通过Tableau制作仪表板分析新冠疫情的传播和疫情现状，进一步练习仪表板的使用。",
            "通过制作仪表板对重要业务指标进行可视化展示是数据分析工作中的一项重要技能。案例通过Tableau制作仪表板分析新冠疫情的传播和疫情现状，进一步练习仪表板的使用。",
          ],
          txt2: [
            ["仪表板架构", "高级图表展示", "地图模块优化", "故事主题分析"],
            ["仪表板架构", "高级图表展示", "地图模块优化", "故事主题分析"],
            ["仪表板架构", "高级图表展示", "地图模块优化", "故事主题分析"],
          ],
        },
        {
          title: ["数据分析报告"],
          txt1: [
            "在数据分析师的日常工作中，经常会需要做定期的报告。例如：日周月报、专题分析报告、竞品分析报告等等，通常以Word或PPT形式呈现。本案例讲解了数据报告制作的全过程，使学员掌握自行制作分析报告的技能。",
            "在数据分析师的日常工作中，经常会需要做定期的报告。例如：日周月报、专题分析报告、竞品分析报告等等，通常以Word或PPT形式呈现。本案例讲解了数据报告制作的全过程，使学员掌握自行制作分析报告的技能。",
            "在数据分析师的日常工作中，经常会需要做定期的报告。例如：日周月报、专题分析报告、竞品分析报告等等，通常以Word或PPT形式呈现。本案例讲解了数据报告制作的全过程，使学员掌握自行制作分析报告的技能。",
          ],
          txt2: [
            [
              "数据分析报告的数据准备",
              "数据分析报告的制作流程",
              "数据分析包括的逻辑框架搭建",
              "数据分析报告的结论撰写",
            ],
            [
              "数据分析报告的数据准备",
              "数据分析报告的制作流程",
              "数据分析包括的逻辑框架搭建",
              "数据分析报告的结论撰写",
            ],
            [
              "数据分析报告的数据准备",
              "数据分析报告的制作流程",
              "数据分析包括的逻辑框架搭建",
              "数据分析报告的结论撰写",
            ],
          ],
        },
      ],
      isPreview: false,
      list: [
        {
          img: null,
          id: 0,
        },
      ],
      showAnswer: false,
      clickedIndex: 0,
      prevItemHeight: 0,
    };
  },

  methods: {
    goTop(index) {
      window.scrollTo(
        0,
        this.$refs.item[index].offsetTop -
          this.$refs.block.offsetHeight -
          this.$refs.block.offsetHeight * 0.3 -
          this.prevItemHeight
      );
    },
    changeCur(index) {
      const a = document.querySelector(".show-answer");
      if (a != null && index > this.cur) {
        this.prevItemHeight = a.offsetHeight;
      }
      if (!this.showAnswer || index <= this.cur) {
        this.prevItemHeight = 0;
      }
      if (index == this.cur) {
        this.showAnswer = !this.showAnswer;
      } else {
        this.showAnswer = true;
        this.cur = index;
      }
      this.goTop(index);
    },
    toLink(item) {
      window.open(item.link);
    },
    close() {
      this.isPreview = false;
    },
    prveImg(index, index2) {
      this.list[0].img = require(`../../../assets/coursePage/dataAnalysis/box9/${
        index + 1
      }${index2 + 1}.png`);
      this.isPreview = true;
    },
  },
};
</script>

<style lang="less" scoped>
.box9 {
  width: 100%;
  .box9block {
    height: 80px;
  }
  .item-box {
    margin: 0 auto;
    width: 690px;
    box-sizing: border-box;
    .item {
      margin-bottom: 20px;
      box-shadow: 0px 12px 32px 0px rgba(94, 98, 218, 0.2);
      border-radius: 18px;
      .content {
        .secondItem:last-child {
          .superiority {
            border-bottom: 0px;
            margin-bottom: 20px;
          }
        }
      }
      // background: #ffffff;
      &:last-child {
        margin-bottom: 0px;
      }
      .item-top {
        display: flex;
        align-items: center;
        position: relative;
        padding: 28px 32px;
        border-radius: 16px;

        width: 100%;
        height: 96px;
        background: #ffffff;
        border-radius: 16px;
        box-sizing: border-box;
        z-index: 5;

        .tag {
          width: 96px;
          height: 40px;
          background: rgba(255, 255, 255, 0.8);
          border-radius: 8px;

          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 700;
          color: #4637b5;
          line-height: 40px;
          box-sizing: border-box;
        }

        .title {
          margin-left: 24px;
          margin-right: 20px;
          width: 472px;
          font-size: 28px;
          font-weight: 700;
        }

        .icon {
          width: 28px;
          height: 28px;
          transition: 0.5s ease all;
          img {
            width: 100%;
            height: 100%;
          }
        }

        .img-rotate {
          transition: 0.5s ease all;
          transform: rotate(180deg);
        }

        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
      }
    }
    .item:nth-child(6) {
      .title {
        margin-right: 5px !important;
      }
    }
    .answer {
      position: relative;
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 0px 0px 20px 20px;
      max-height: 0;
      opacity: 0;
      transition: 0.3s ease all;
      overflow: hidden;
      z-index: 3;
      padding: 0px 40px 0px;
      .line {
        margin-bottom: 34px;
        width: 100%;
        border-top: 1px solid #f2f3f5;
      }
      .infotitle {
        font-size: 26px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1d2129;
        line-height: 44px;
      }
      .info {
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #4e5969;
        line-height: 44px;
        margin: 24px 0;
      }
      .superiority {
        display: flex;
        justify-content: space-between;
        padding-bottom: 15px;
        border-bottom: 1px solid #f2f3f5;
        margin: 0 -12px 28px;
        padding: 0 12px 6px;
        .text {
          p {
            margin-bottom: 16px;
            width: max-content;

            background: rgba(106, 161, 255, 0.1);
            border-radius: 10px;

            padding: 8px 20px;

            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #4e5969;
            line-height: 40px;
            text-align: center;
          }
        }

        .img-box {
          position: relative;
          flex-shrink: 0;
          min-width: 212px;
          max-width: 212px;
          height: 163px;

          border-radius: 10px;
          overflow: hidden;
          width: 222px;
          height: 160px;
          background: #d8d8d8;
          border-radius: 12px;
          border: 1px solid #ac98f6;
          box-sizing: border-box;
          &::after {
            position: absolute;
            bottom: 0px;
            left: 0px;
            content: "点击查看原图";
            width: 156px;
            height: 52px;

            border-radius: 0px 26px 0px 0px;
            opacity: 0.5;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 52px;
            letter-spacing: 0px;
            color: #ffffff;
            background: rgba(19, 0, 47, 1);
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }
    }
    .show-answer {
      padding: 0px 40px 0px;
      // display: block;
      max-height: 1800px;
      opacity: 1;
      transition: 0.4s ease all;
    }
  }
}
</style>
